module.exports = __webpack_public_path__ + "img/29.19d424a4.jpg";